import styled from 'styled-components'

export default styled.div`
  @media(min-width: 1100px) {
    max-width: 1080px;
    margin: 0 auto;
  }
  @media(max-width: 1099px) {
    margin: 0px 10px;
    width: calc(100% - 20px);
  }
`



// WEBPACK FOOTER //
// ./src/components/GridContainer.js